<template>
  <div class="myorders flex-grow flex flex-col">
    <section class="text-center flex-grow flex flex-col justify-between">
      <div class="w-full">
        <h1 class="text-3xl text-gray-800 pt-6 mb-4">{{ $t('My Open Orders') }}</h1>
        <div
          v-for="(item, index) in activeOrders"
          :key="index"
          class="bg-white mx-3 my-6 rounded-lg shadow-lg flex flex-col px-4 py-6 text-lg"
          @click="handleGoToOrder(item.id)"
        >
          <div v-for="(i, ii) in itemsFiltered(item.items)" :key="ii">
            <div class="flex justify-between mb-2">
              <p>{{ i[0] }}</p>
              <div class="flex items-center">
                <p class="text-xl mx-1">{{ i[1].quantity }}</p>
                <p class="text-xl font-bold mx-1">x</p>
                <p class="text-xl mx-1">${{ i[1].price.toFixed(2) }}</p>
                <p class="text-xl font-bold mx-1">=</p>
                <p class="text-xl bg-app-green text-white px-1 py-1 rounded-lg w-16">
                  ${{ (i[1].quantity * i[1].price).toFixed(2) }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-2 text-left text-lg" v-show="item.status === 'ready'">
            <p>{{ $t("Your order is ready and on it's way to you!") }}!</p>
          </div>
          <div class="mt-2 text-left text-lg" v-show="item.status === 'approved'">
            <p
              v-if="
                (item.timeLeft.minutes > 0 && item.timeLeft.seconds > -1) ||
                  (item.timeLeft.minutes == 0 && item.timeLeft.seconds > -1)
              "
            >
              {{ $t('Estimated Time') }}: {{ item.timeLeft.minutes }} {{ $t('mins') }} {{ item.timeLeft.seconds }}
              {{ $t('seconds until your order is ready') }}!
            </p>
            <p v-if="item.timeLeft.minutes <= 0 && item.timeLeft.seconds <= 0">{{ $t('Your order is on the way') }}</p>
          </div>
        </div>

        <div class="bg-white mx-3 my-6 rounded-lg shadow-lg flex justify-between px-4 py-6 text-lg">
          <div class="flex items-center">
            <eva-icon
              name="shopping-cart-outline"
              animation="pulse"
              width="35"
              height="35"
              fill="#384E77"
              class="mr-4"
            ></eva-icon>
            <p class="font-bold text-xl">{{ $t('Total') }}</p>
          </div>
          <p class="font-bold text-xl">$ {{ total.toFixed(2) }}</p>
        </div>
      </div>
      <div class="flex">
        <button
          class="mx-auto mt-6 mb-6 rounded-full bg-green-400 text-center px-4 py-2 font-light text-white"
          @click="handleCloseTap"
        >
          {{ $t('Close Tap') }}
        </button>
        <button
          class="mx-auto mt-6 mb-6 rounded-full bg-red-600 text-center px-4 py-2 font-light text-white"
          @click="handleGoToMenu"
        >
          {{ $t('Go back to Menu') }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import { db, auth } from '@/firebase';

export default {
  name: 'MyOrders',
  data() {
    return {
      activeOrders: [],
      total: 0,
    };
  },
  created() {
    const { uid } = auth.currentUser;

    try {
      db.collectionGroup('orders')
        .where('customer', '==', uid)
        .get()
        .then(querySnapshot => {
          const validOptions = ['approved', 'pending', 'ready'];
          const activeOrders = [];
          let tTotal = 0;
          querySnapshot.forEach(doc => {
            const { status, items, approvedTime, prepTime, ...rest } = doc.data();
            if (validOptions.includes(status)) {
              let minutes = 0;
              let seconds = 0;
              if (approvedTime) {
                const eT = moment.unix(approvedTime.seconds).add(prepTime, 'minutes');
                const current = moment();
                const durat = moment.duration(eT.diff(current));
                minutes = durat.minutes();
                seconds = durat.seconds();
              }

              const total = this.itemsTotal(items);
              tTotal += total;
              activeOrders.push({
                ...rest,
                approvedTime,
                prepTime,
                items,
                total,
                status,
                id: doc.id,
                timeLeft: { minutes, seconds },
              });
            }
          });
          this.activeOrders = activeOrders;
          this.total = tTotal;
        });
    } catch (e) {
      console.log('e :', e);
    }
    this.countDownTimer();
  },
  methods: {
    itemsFiltered(items) {
      const d = {};
      items.forEach(i => {
        const { name, price } = i;
        if (d[name]) {
          d[name].quantity += 1;
        } else {
          d[name] = { quantity: 1, price };
        }
      });
      return Object.entries(d);
    },
    handleGoToOrder(orderId) {
      this.$router.push(`/order/${orderId}`);
    },
    itemsTotal(items) {
      return items.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
    },
    async handleCloseTap() {
      const changes = [];
      let closable = true;
      this.activeOrders.forEach(order => {
        if (order.status !== 'ready') {
          closable = false;
        }
      });
      if (closable) {
        try {
          this.activeOrders.forEach(order => {
            const { id, items } = order;
            const { restaurant } = items[0];
            changes.push(
              db
                .collection(`/restaurants/${restaurant}/orders`)
                .doc(id)
                .update({ status: 'closed' }),
            );
          });
          await Promise.all(changes);
          this.$toasted.success(this.$t('Tap closed! Your bill is on the way!'), {
            theme: 'bubble',
            position: 'top-center',
            duration: 3000,
          });
          localStorage.removeItem('latestTable', this.table);
          this.activeOrders = [];
        } catch (e) {
          console.log('e :', e);
        }
      } else {
        this.$toasted.info(this.$t("There are in progress orders. You can't close this tap"), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      }
    },
    handleGoToMenu() {
      if (this.activeOrders.length > 0) {
        const { items } = this.activeOrders[0];
        const { restaurant } = items[0];
        if (restaurant) this.$router.push(`/restaurants/${restaurant}`);
      } else this.$router.push('/restaurants');
    },
    countDownTimer() {
      setInterval(() => {
        this.activeOrders.forEach((o, index) => {
          const { status, timeLeft, approvedTime, prepTime } = o;
          if (timeLeft && status === 'approved') {
            const eT = moment.unix(approvedTime.seconds).add(prepTime, 'minutes');
            const current = moment();
            const durat = moment.duration(eT.diff(current));
            const minutes = durat.minutes();
            const seconds = durat.seconds();

            this.activeOrders[index].timeLeft.minutes = minutes;
            this.activeOrders[index].timeLeft.seconds = seconds;
          }
        });
      }, 1000);
    },
  },
};
</script>

<style></style>
